var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoCircleBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99967 0.333008C3.31778 0.333008 0.333008 3.31778 0.333008 6.99967C0.333008 10.6816 3.31778 13.6663 6.99967 13.6663C10.6816 13.6663 13.6663 10.6816 13.6663 6.99967C13.6624 3.31943 10.6799 0.336988 6.99967 0.333008ZM7.13856 3.11079C7.5988 3.11079 7.9719 3.48388 7.9719 3.94412C7.9719 4.40436 7.5988 4.77745 7.13856 4.77745C6.67833 4.77745 6.30523 4.40436 6.30523 3.94412C6.30523 3.48388 6.67833 3.11079 7.13856 3.11079ZM8.38856 10.6108H6.16634C5.85952 10.6108 5.61079 10.3621 5.61079 10.0552C5.61079 9.7484 5.85952 9.49967 6.16634 9.49967H6.58301C6.65971 9.49967 6.7219 9.43749 6.7219 9.36079V6.86079C6.7219 6.78408 6.65971 6.7219 6.58301 6.7219H6.16634C5.85952 6.7219 5.61079 6.47317 5.61079 6.16634C5.61079 5.85952 5.85952 5.61079 6.16634 5.61079H6.7219C7.33555 5.61079 7.83301 6.10825 7.83301 6.7219V9.36079C7.83301 9.43749 7.89519 9.49967 7.9719 9.49967H8.38856C8.69539 9.49967 8.94412 9.7484 8.94412 10.0552C8.94412 10.3621 8.69539 10.6108 8.38856 10.6108Z",
    fill: "#2B3A41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircleBlue);
export default __webpack_public_path__ + "static/media/info-circle-blue.254aa29b.svg";
export { ForwardRef as ReactComponent };